import React from "react";
import ReactTooltip from "react-tooltip";
import { css } from "react-emotion";

import { colors } from "../consts";

const tooltipStyles = css`
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  .tooltip-wrapper {
    display: flex;
    justify-content: center;
  }
  .tooltip-name {
    margin-right: 10px;
    margin-bottom: 0;
    color: ${colors.primary};
  }
  .tooltip-value {
    margin-bottom: 0;
    font-weight: 600;
    color: ${colors.primaryDark};
  }
  .tooltip-download {
    text-align: center;
    font-size: 12px;
    color: ${colors.primary};
    margin: 0;
    &.mt {
      margin-top: 4px;
    }
  }
`;

export default props => (
  <ReactTooltip type="light" className={tooltipStyles} html={true} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/Tooltip.js